module.exports = __webpack_public_path__ + "img/Warrior-human-f-60.574908eb.gif";